import { render, staticRenderFns } from "./ServiceRentalItem.vue?vue&type=template&id=de84404a&scoped=true"
import script from "./ServiceRentalItem.vue?vue&type=script&lang=js"
export * from "./ServiceRentalItem.vue?vue&type=script&lang=js"
import style0 from "./ServiceRentalItem.vue?vue&type=style&index=0&id=de84404a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de84404a",
  null
  
)

export default component.exports